import { Link } from "react-router-dom";
import { services } from "@/data/services";
import { cities } from "@/data/cities";
import { RevealBlock } from "@/components/Reveal";

// A dense, editorial internal-linking block — the "keyword atlas".
// Renders ~50 sample combos on the home page so bots see fast linking.
export default function KeywordAtlas() {
  const featuredServices = services.slice(0, 6);
  const featuredCities = cities.slice(0, 10);
  const combos = [];
  featuredServices.forEach((s) => {
    featuredCities.forEach((c) => {
      combos.push({ s, c });
    });
  });

  return (
    <section className="bg-[#F5F3EF] border-t border-[#D9D6D0] py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-4 mb-12">
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-6">
              — Keyword Atlas
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <RevealBlock>
              <h2 className="font-serif text-[clamp(2rem,5vw,5rem)] leading-[0.95] tracking-tighter text-[#111111]">
                Every service ×<br />
                <span className="italic text-[#184C59]">every community.</span>
              </h2>
            </RevealBlock>
            <p className="mt-6 font-sans text-base md:text-lg text-[#111111]/70 max-w-[60ch]">
              A dedicated landing page for every combination — {services.length} services × {cities.length} communities. Written for search engines, built for the humans who read them next.
            </p>
          </div>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-1.5 border-t border-[#111111] pt-8">
          {combos.map(({ s, c }) => (
            <li key={`${s.slug}-${c.slug}`}>
              <Link
                to={`/services/${s.slug}/${c.slug}`}
                className="group flex items-baseline justify-between border-b border-[#D9D6D0] py-2 hover:border-[#111111]"
              >
                <span className="font-serif text-lg text-[#111111]/80 group-hover:italic group-hover:text-[#C17A43] transition-colors">
                  {s.shortName || s.name} · {c.name}
                </span>
                <span className="opacity-30 group-hover:opacity-100 group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            </li>
          ))}
        </ul>

        <div className="mt-8 flex justify-end">
          <Link
            to="/coverage"
            className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#111111] border-b border-[#111111] pb-1 hover:text-[#C17A43] hover:border-[#C17A43]"
          >
            View the full coverage atlas →
          </Link>
        </div>
      </div>
    </section>
  );
}
